import React from 'react';
import { defaultThresholds } from '../config/thresholds';

interface LegendItem {
  color: string;
  label: string;
  description: string;
  threshold?: string;
}

const MonitoringLegend: React.FC = () => {
  const formatThreshold = (type: 'noise' | 'tsp' | 'vibration'): string => {
    const config = defaultThresholds[type];
    // Alert threshold
    if (config.max !== undefined) {
      return `>${config.max}`;
    }
    if (config.min !== undefined) {
      return `<${config.min}`;
    }
    return '';
  };

  const getUnit = (type: 'noise' | 'tsp' | 'vibration'): string => {
    switch (type) {
      case 'noise':
        return 'dB';
      case 'tsp':
        return 'ug/m³';
      case 'vibration':
        return 'mm/s';
      default:
        return '';
    }
  };

  const getAlertThreshold = (): string => {
    const noise = formatThreshold('noise');
    const tsp = formatThreshold('tsp');
    const vibration = formatThreshold('vibration');
    const parts: string[] = [];
    // if (noise) parts.push(`Noise: ${noise}${getUnit('noise')}`);
    // if (tsp) parts.push(`TSP: ${tsp}${getUnit('tsp')}`);
    //if (vibration) parts.push(`Vibration: ${vibration}${getUnit('vibration')}`);
    if (vibration) parts.push(`Location-specific`);
    return parts.join(', ');
  };

  const legendItems: LegendItem[] = [
    {
      color: 'bg-blue-600',
      label: 'Normal',
      description: 'Within acceptable range'
    },
    {
      color: 'bg-red-700',
      label: 'Alert',
      description: 'Exceeds threshold',
      threshold: getAlertThreshold()
    },
    {
      color: 'bg-gray-500',
      label: 'Inactive',
      description: 'Data older than 1 minute'
    }
  ];

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="text-sm font-medium text-gray-300">Status:</span>
      <div className="flex flex-wrap items-center gap-3">
        {legendItems.map((item, index) => (
          <div key={index} className="flex items-center gap-1.5">
            <div className={`${item.color} w-3 h-3 rounded border border-gray-400`}></div>
            <span className="text-xs text-gray-300">{item.label}</span>
            {item.threshold && (
              <span className="text-xs text-gray-400">({item.threshold})</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonitoringLegend;

